import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'

import { formatDate, roundCurrency } from '@atheneum/api/dist/lib'

import Pagination from '@components/Pagination/Pagination'

class Table extends Component {
  static propTypes = {
    historyStore: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      page: 1
    })

    this.props.historyStore.getCosts()
  }

  render () {
    return (
      <div>
        <table className='table-wrapper expert-history'>
          <thead>
            <tr className='title'>
              <th>Project name</th>
              <th>Type</th>
              <th>Recording date</th>
              <th>Comment</th>
              <th>Value</th>
              <th>Payment status</th>
            </tr>
          </thead>
          <tbody>
            {this.props.historyStore.costs.rows.map(cost => (
              <TableRow
                key={cost.feeId}
                row={cost}
                staticData={this.props.staticData}
              />
            ))}
          </tbody>
        </table>

        <Pagination
          total={this.props.historyStore.costs.count}
          perPage={10}
          page={this.page}
          onChange={p => {
            this.page = p
            this.props.historyStore.getCosts(p)
          }}
        />
      </div>
    )
  }
}

const TableRow = ({ row, staticData }) => {
  return (
    <tr>
      <td>
        <Link to={/project/ + row.projectId}>{row.projectName}</Link>
        <span className='desc desc--top-spacing'>
          {formatDate(row.startDate)} -{' '}
          {row.endDate ? formatDate(row.endDate) : 'Current'}
        </span>
      </td>
      <td>{staticData.names.costTypes[row.costTypeId]}</td>
      <td>{formatDate(row.recordingDate)}</td>
      <td>{row.comment}</td>
      <td>
        {roundCurrency(row.value)} {staticData.names.currencies[row.currencyId]}
      </td>
      <td>{staticData.names.paymentStatuses[row.paymentStatusId]}</td>
    </tr>
  )
}
TableRow.propTypes = {
  row: PropTypes.object.isRequired,
  staticData: PropTypes.object.isRequired
}

export default withRouter(inject('historyStore', 'staticData')(observer(Table)))
